<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="cont"><a id="page_vii"></a><strong>Contents</strong></h2>
<p class="tocfront"><a class="nounder" href="#/xhtml/intro#intro">Introduction: Back to the Future</a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch01#ch01">C<span class="small">HAPTER</span> 1    Bring My Job Home!</a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">C<span class="small">HAPTER</span> 2    Roll Back the Reagan Tax Cuts</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">C<span class="small">HAPTER</span> 3    Stop Them from Eating My Town</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">C<span class="small">HAPTER</span> 4    An Informed and Educated Electorate</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">C<span class="small">HAPTER</span> 5    Medicare “Part E”—for Everybody</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">C<span class="small">HAPTER</span> 6    Make Members of Congress Wear NASCAR Patches</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">C<span class="small">HAPTER</span> 7    Cool Our Fever</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">C<span class="small">HAPTER</span> 8    They Will Steal It!</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">C<span class="small">HAPTER</span> 9    Put Lou Dobbs out to Pasture</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">C<span class="small">HAPTER</span> 10  Wal-Mart Is <em>Not</em> a Person</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">C<span class="small">HAPTER</span> 11  In the Shadow of the Dragon</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/conc#conc" title="Link target outside of Sample">Conclusion: Tag, You’re It!</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/ack#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/notes#notes" title="Link target outside of Sample">Notes</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample">Index</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/about#about" title="Link target outside of Sample">About the Author</span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7700c7f8